import classNames from 'classnames';
import {observer} from 'mobx-react';
import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Icon} from '@udemy/icons';
import {IconButton} from '@udemy/react-core-components';
import {safelySetInnerHTML} from '@udemy/shared-utils';
import {Discount, DISCOUNT_STATUSES, SOURCE_TYPE} from '@udemy/shopping';

import styles from '../redeem-coupon/redeem-coupon.module.less';

interface ValidDiscountProps {
    removeCoupon: () => void;
    attemptDiscount: Discount;
    isInCheckoutPane?: boolean;
}

export const ValidDiscount: React.FC<ValidDiscountProps> = observer(
    ({removeCoupon, attemptDiscount, isInCheckoutPane = false}) => {
        const {gettext, interpolate} = useI18n();

        if (attemptDiscount.status != DISCOUNT_STATUSES.APPLIED) return <></>;

        const translatedText = interpolate(
            gettext('<b>%(couponCode)s</b> is applied'),
            {couponCode: attemptDiscount.code},
            true,
        );

        const SOURCE_TYPE_TEXT = {
            UDEMY_COUPON: gettext('Udemy coupon'),
            INSTRUCTOR_COUPON: gettext('Instructor coupon'),
        };

        let sourceTypeText: string | null = null;

        switch (attemptDiscount.source_type) {
            case SOURCE_TYPE.UDEMY_COUPON:
                sourceTypeText = SOURCE_TYPE_TEXT.UDEMY_COUPON;
                break;
            case SOURCE_TYPE.INSTRUCTOR_COUPON:
                sourceTypeText = SOURCE_TYPE_TEXT.INSTRUCTOR_COUPON;
                break;
        }

        return (
            <div
                className={classNames(styles.code, {
                    [styles['code-in-checkout-pane']]: isInCheckoutPane,
                })}
            >
                <div className={styles['code-text']}>
                    <ul>
                        <li
                            {...safelySetInnerHTML({
                                descriptionOfCaller: 'redeem-coupon:code-text',
                                html: translatedText,
                                dataPurpose: 'code-text',
                            })}
                        />
                        {sourceTypeText && <li>{sourceTypeText}</li>}
                    </ul>
                </div>
                <IconButton
                    className={styles['code-icon-button']}
                    udStyle="ghost"
                    onClick={removeCoupon}
                >
                    <Icon
                        glyph="close"
                        label={false}
                        color={isInCheckoutPane ? 'neutral' : 'info'}
                        size="small"
                    />
                </IconButton>
            </div>
        );
    },
);
